import { Link } from 'react-router-dom'
import { Button } from '../components/ui'
import { Logo } from '../components/Logo'

export default function NotFound() {
  return (
    <div style={{
      minHeight: '100dvh', display: 'grid', placeItems: 'center',
      padding: 'var(--sp-6)', textAlign: 'center',
    }}>
      <div style={{ maxWidth: 400 }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 'var(--sp-8)' }}>
          <Logo />
        </div>
        <div style={{
          fontSize: '3.5rem', fontWeight: 700, lineHeight: 1,
          color: 'var(--text-subtle)', marginBottom: 'var(--sp-4)',
        }}>
          404
        </div>
        <h1 style={{ marginBottom: 'var(--sp-3)' }}>Page not found</h1>
        <p style={{ color: 'var(--text-muted)', marginBottom: 'var(--sp-8)' }}>
          That page doesn&rsquo;t exist, or you may not have access to it.
        </p>
        <Link to="/"><Button>Back to dashboard</Button></Link>
      </div>
    </div>
  )
}
